import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Chapter, FadeUp } from "@/components/Reveal";
import { SERVICES } from "@/data/services";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Services() {
  const { t } = useLanguage();
  const items = t("services.items");

  return (
    <section id="services" className="py-28 md:py-40" data-testid="services-section">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Chapter number="03" title={t("chapters.services")} />
        <FadeUp>
          <h2 className="mb-14 max-w-3xl text-balance font-syne text-3xl font-bold leading-[1.12] tracking-tight sm:text-4xl lg:text-[3.4rem] md:mb-20" data-testid="services-heading">
            {t("services.headingA")} <span className="text-[#F97316]">{t("services.headingB")}</span>
          </h2>
        </FadeUp>
        <div>
          {SERVICES.map((s, i) => {
            const text = items[s.slug];
            return (
              <FadeUp key={s.slug} delay={i * 0.05}>
                <Link
                  to={`/services/${s.slug}`}
                  className={`group flex items-center justify-between gap-6 border-t border-white/10 py-7 transition-[padding] duration-500 hover:pl-4 md:py-9 ${
                    i === SERVICES.length - 1 ? "border-b" : ""
                  }`}
                  data-testid={`service-row-${i + 1}`}
                >
                  <div className="flex items-baseline gap-6 md:gap-10">
                    <span className="font-spacemono text-xs text-white/30 transition-colors duration-500 group-hover:text-[#F97316]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div>
                      <h3 className="font-syne text-2xl font-bold uppercase tracking-tight text-white/85 transition-colors duration-500 group-hover:text-[#F97316] sm:text-3xl md:text-5xl">
                        {text.name}
                      </h3>
                      <p className="mt-2 font-spacemono text-[10px] uppercase tracking-[0.25em] text-white/35 md:hidden">
                        {text.tag}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-8">
                    <span className="hidden font-spacemono text-[11px] uppercase tracking-[0.25em] text-white/35 md:block">
                      {text.tag}
                    </span>
                    <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/15 transition-[background-color,border-color,transform] duration-500 group-hover:rotate-45 group-hover:border-[#F97316] group-hover:bg-[#F97316]">
                      <ArrowUpRight className="h-4 w-4 text-white transition-colors duration-500" />
                    </span>
                  </div>
                </Link>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
